import HeaderSearchBar from "../../HeaderSearchBar/@stores/HeaderSearchBar.store.js";

class HeaderSearchDrawerStore extends HeaderSearchBar {
	constructor(rootStore, staticContext) {
		super(rootStore, staticContext);
	}
}

export default HeaderSearchDrawerStore;
